import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import { getLevelColors } from '../utils/chartColors';

ChartJS.register(ArcElement, Tooltip, Legend);

const BooksPerLevelChart = ({ data, isDarkMode, periodLabel = 'Levels 1-9' }) => {
  const textColor = isDarkMode ? '#e5e7eb' : '#333333';
  const cardBg = isDarkMode ? '#1f2937' : '#ffffff';
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const chartData = {
    labels: data.map(item => `Level ${item.level}`),
    datasets: [
      {
        label: 'Books',
        data: data.map(item => item.count),
        backgroundColor: getLevelColors(data.map(item => item.level), isDarkMode),
        borderColor: cardBg,
        borderWidth: 3,
        hoverBorderWidth: 4,
        hoverBorderColor: cardBg,
        hoverOffset: 15
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '60%',
    plugins: {
      legend: {
        position: isMobile ? 'bottom' : 'right',
        labels: {
          color: textColor,
          font: {
            size: 12,
            family: "'Inter', sans-serif"
          },
          padding: 15,
          usePointStyle: true,
          pointStyle: 'circle'
        }
      },
      tooltip: {
        backgroundColor: 'rgba(51, 51, 51, 0.95)',
        padding: 12,
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: '#3491f7',
        borderWidth: 1,
        displayColors: false,
        callbacks: {
          label: (context) => {
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `Books: ${value.toLocaleString()} (${percentage}%)`;
          }
        }
      }
    },
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 1500,
      easing: 'easeInOutQuart'
    }
  };

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h3>Published Books Per Level</h3>
        <span className="chart-badge">{periodLabel}</span>
      </div>
      <div className="chart-wrapper">
        <Doughnut data={chartData} options={options} />
      </div>
    </div>
  );
};

export default BooksPerLevelChart;
